import { Component, computed, inject, signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Location } from '@angular/common';
import { SortEvent, SortState } from "@app/shared/models/sort.model";
import { FilterSortService } from "@app/shared/services/filter-sort.service";
import { BadgeComponent, ButtonComponent, CheckboxComponent, DividerComponent, FormFieldComponent, IconComponent, LabelComponent, OptionComponent, PlaceholderComponent, SelectComponent, SubHeaderComponent, Table2Component } from "@pansa/ui";
import { AuthorizedEntityService } from "../../services/authorized-entity.service";
import { LinkAccountDTO } from "../../models/link-account.model";
import { GroupColorPipe } from "@app/features/groups/pipes/group-color.pipe";
import { GroupTypeEnum } from "@app/features/groups/models/group.model";


@Component({
  selector: 'rqa-link-account',
  templateUrl: './link-account.component.html',
  styleUrl: './link-account.component.scss',
  imports: [Table2Component, FormsModule, ReactiveFormsModule, GroupColorPipe, BadgeComponent, OptionComponent, SelectComponent, PlaceholderComponent, LabelComponent, FormFieldComponent, DividerComponent, IconComponent, SubHeaderComponent, ButtonComponent, CheckboxComponent],
})
export class LinkAccountComponent {
  private authorizedEntityService = inject(AuthorizedEntityService);
  private filterService = inject(FilterSortService);
  private location = inject(Location);
  trackBy: keyof LinkAccountDTO = 'id';
  groupTypeOptions: string[] = Object.values(GroupTypeEnum);
  selectedUsers = signal<LinkAccountDTO[]>([]);

  someSelected = computed(() => {
    const filtered = this.filteredUsers();
    const selectedUsernames = new Set(this.selectedUsers().map((u) => u.username));

    const selectedCount = filtered.filter((u) => selectedUsernames.has(u.username)).length;

    return selectedCount > 0 && selectedCount < filtered.length;
  });

  allSelected = computed(() => {
    const filtered = this.filteredUsers();
    const selected = this.selectedUsers();

    return filtered.length > 0 && filtered.every((u) => selected.some((s) => s.username === u.username));
  });

  isSelected = (user: LinkAccountDTO) => {
    return this.selectedUsers().some((u) => u.username === user.username);
  };

  users = toSignal(this.authorizedEntityService.getLinkUsers(), {
    initialValue: [] as LinkAccountDTO[]
  });

  filtersForm = new FormGroup({
    global: new FormControl(''),
    group: new FormControl('Wszystkie')
  });

  filters = toSignal(this.filtersForm.valueChanges, { initialValue: this.filtersForm.value });

  readonly sort = signal<SortState>({
    key: 'id',
    direction: ''
  });

  filteredUsers = this.filterService.connect({
    data: this.users,
    filters: this.filters,
    sort: this.sort
  });

  onGoBack(): void {
    this.location.back()
  }

  onSubmit(): void {

  }

  toggleUser(user: LinkAccountDTO) {
    this.selectedUsers.update((selected) =>
      selected.some((u) => u.username === user.username)
        ? selected.filter((u) => u.username !== user.username)
        : [...selected, user]
    );
  }

  toggleAll() {
    const filtered = this.filteredUsers();
    const selected = this.selectedUsers();

    if (this.allSelected()) {
      this.selectedUsers.set(selected.filter((u) => !filtered.some((f) => f.username === u.username)));
    } else {
      const newOnes = filtered.filter((f) => !selected.some((s) => s.username === f.username));
      this.selectedUsers.set([...selected, ...newOnes]);
    }
  }


}
